import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';
import './Register.css';

export default function Register() {
  const brand = useBrand();
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();

  // Step 1: Forening
  const [associationName, setAssociationName] = useState('');
  const [cvr, setCvr] = useState('');

  // Step 2: Bruger
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const goToStep2 = (e) => {
    e.preventDefault();
    setError('');
    if (!associationName.trim()) {
      setError(`${brand.register.orgNameLabel} er påkrævet.`);
      return;
    }
    setStep(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) { setError('Dit navn er påkrævet.'); return; }
    if (!email.trim()) { setError('E-mail er påkrævet.'); return; }
    if (!password) { setError('Adgangskode er påkrævet.'); return; }
    if (password.length < 6) { setError('Adgangskode skal være mindst 6 tegn.'); return; }
    if (password !== passwordConfirm) { setError('Adgangskoderne er ikke ens.'); return; }

    setSaving(true);
    try {
      const res = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          associationName: associationName.trim(),
          cvr: cvr.trim(),
          name: name.trim(),
          email: email.trim(),
          username: email.trim(),
          password
        })
      });

      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Der opstod en fejl.');
        setSaving(false);
        return;
      }

      // Auto-login med den returnerede token
      loginWithToken(data.token, data.user);
      navigate('/app');
    } catch (err) {
      setError('Kunne ikke oprette forbindelse til serveren.');
      setSaving(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-box">
        <Link to="/" className="register-logo">
          <span className="register-logo-icon">{brand.logoIcon}</span>
          <span>{brand.name}<span className="register-logo-dk">.dk</span></span>
        </Link>

        <h1>{brand.register.title}</h1>
        <p className="register-subtitle">{brand.register.subtitle}</p>

        {/* Progress steps */}
        <div className="register-progress">
          <div className={`register-progress-step ${step >= 1 ? 'active' : ''}`}>
            <div className="register-progress-dot">{step > 1 ? '✓' : '1'}</div>
            <span>{brand.register.step1Label}</span>
          </div>
          <div className="register-progress-line"></div>
          <div className={`register-progress-step ${step >= 2 ? 'active' : ''}`}>
            <div className="register-progress-dot">2</div>
            <span>Din konto</span>
          </div>
        </div>

        {error && <div className="register-error">{error}</div>}

        {step === 1 && (
          <form onSubmit={goToStep2}>
            <div className="register-field">
              <label>{brand.register.orgNameLabel} *</label>
              <input
                type="text"
                value={associationName}
                onChange={e => setAssociationName(e.target.value)}
                placeholder={brand.register.orgNamePlaceholder}
                autoFocus
              />
            </div>
            <div className="register-field">
              <label>CVR-nummer <span className="register-optional">(valgfrit)</span></label>
              <input
                type="text"
                value={cvr}
                onChange={e => setCvr(e.target.value)}
                placeholder="F.eks. 12345678"
                maxLength={8}
              />
            </div>
            <button type="submit" className="register-btn register-btn-primary">
              Fortsæt
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleSubmit}>
            <div className="register-field">
              <label>Dit fulde navn *</label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="F.eks. Lilian Hansen"
                autoFocus
              />
            </div>
            <div className="register-field">
              <label>E-mail *</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="din@email.dk"
                required
              />
            </div>
            <div className="register-row">
              <div className="register-field">
                <label>Adgangskode *</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Mindst 6 tegn"
                />
              </div>
              <div className="register-field">
                <label>Gentag adgangskode *</label>
                <input
                  type="password"
                  value={passwordConfirm}
                  onChange={e => setPasswordConfirm(e.target.value)}
                  placeholder="Gentag adgangskode"
                />
              </div>
            </div>
            <div className="register-actions">
              <button type="button" className="register-btn register-btn-back" onClick={() => { setStep(1); setError(''); }}>
                ← Tilbage
              </button>
              <button type="submit" className="register-btn register-btn-primary" disabled={saving}>
                {saving ? 'Opretter...' : brand.register.submitButton}
              </button>
            </div>
          </form>
        )}

        <div className="register-footer-note">
          <p>Har du allerede en konto? <Link to="/login">Log ind her</Link></p>
        </div>

        <div className="register-trust">
          <div>Gratis oprettelse</div>
          <div>1 md. gratis</div>
          <div>Ingen binding</div>
        </div>
      </div>
    </div>
  );
}
